import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, getMe } from '@/lib/api';

// More robust admin gate that tolerates enriched user shapes and performs a lazy /auth/me when needed.
export default function RequireAdmin({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const deriveIsAdmin = (u) => {
    if (!u) return false;
    const normalized = u?.user ? { ...u, ...u.user } : u;
    const roleCandidate = normalized.role || normalized.role_name || normalized.user?.role || normalized.user?.role_name;
    const roleId = normalized.role_id || normalized.user?.role_id;
    return (
      (roleCandidate && String(roleCandidate).toLowerCase() === 'admin') || roleId === 1
    );
  };

  const checkLocal = () => {
    const u = getCurrentUser();
    setIsAdmin(deriveIsAdmin(u));
    return !!u;
  };

  useEffect(() => {
    let mounted = true;
    async function init() {
      const hasLocal = checkLocal();
      const token = localStorage.getItem('tdv_auth_token');
      if (!hasLocal && token) {
        // Attempt to enrich session before deciding.
        try {
          await getMe(); // merges user into localStorage
          checkLocal();
        } catch (e) {
          console.warn('RequireAdmin getMe failed:', e);
        }
      }
      if (mounted) setLoading(false);
    }
    init();
    const handler = () => { checkLocal(); };
    window.addEventListener('authChange', handler);
    window.addEventListener('storage', handler);
    return () => {
      mounted = false;
      window.removeEventListener('authChange', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  if (loading) return <div className="flex justify-center py-12 text-sm text-muted-foreground">Checking admin rights…</div>;
  if (!isAdmin) {
    const token = localStorage.getItem('tdv_auth_token');
    return <Navigate to={token ? '/login' : '/'} replace state={{ from: location }} />;
  }
  return children;
}